import { Directive, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

declare const $;

@Directive({
	selector: '[appResizeLeft]'
})
export class ResizeLeftDirective {
	// eslint-disable-next-line @angular-eslint/no-input-rename
	@Input('component') componentData;
	@Input() elementNumber;
	@Output() stopped = new EventEmitter<any>();

	startX = 0;
	x = 0;
	parentWidth = 0;
	parentLeft = 0;
	backgroundTop = 0;
	mouseDown = false;

	@HostListener('mousedown', ['$event'])
	onMousedown(event) {
		event.preventDefault();
		event.stopPropagation();
		this.startX = event.screenX;
		this.x = 0;
		this.parentWidth = $(this.el.nativeElement).parent()[0].clientWidth;
		if (this.componentData.config.type === 50) {
			this.parentLeft = this.componentData.config.items[this.elementNumber].left;
			this.backgroundTop = this.componentData.config.items[this.elementNumber].top;
		} else if (this.componentData.config.type === 23 && this.componentData.config.version > 1) {
			this.parentLeft = this.componentData.config.merge_array[this.elementNumber].parser.left_offset;
			this.backgroundTop = this.componentData.config.merge_array[this.elementNumber].parser.top_offset;
		} else {
			this.parentLeft = this.componentData.config.parser.left_offset;
			this.backgroundTop = this.componentData.config.parser.top_offset;
		}
		this.mouseDown = true;
	}

	@HostListener('document:mousemove', ['$event'])
	onMousemove(event: MouseEvent) {
		if (this.mouseDown) {
			event.preventDefault();
			this.x = event.screenX - this.startX;

			let widthToChange;
			if (this.parentWidth + this.x > 1180) {
				widthToChange = 1180;
			} else {
				widthToChange = this.parentWidth - this.x;
			}
			const leftToChange = this.parentLeft + this.x;

			$(this.el.nativeElement)
				.parent()
				.css({
					width: widthToChange + 'px',
					left: leftToChange + 'px',
					'background-position': '-' + leftToChange + 'px -' + this.backgroundTop + 'px'
				});
		}
	}

	@HostListener('document:mouseup')
	onMouseup() {
		if (this.mouseDown) {
			this.mouseDown = false;
			if (this.componentData.config.type === 50) {
				this.stopped.emit({
					width: this.parentWidth + this.x > 1180 ? 1180 : this.parentWidth - this.x,
					left: this.parentLeft + this.x
				});
			} else if (this.componentData.config.type === 23 && this.componentData.config.version > 1) {
				this.componentData.config.merge_array[this.elementNumber].item_width =
					this.parentWidth + this.x > 1180 ? 1180 : this.parentWidth - this.x;
				this.componentData.config.merge_array[this.elementNumber].parser.left_offset = this.parentLeft + this.x;
				this.stopped.emit(this.componentData);
			} else {
				this.componentData.config.item_width = this.parentWidth + this.x > 1180 ? 1180 : this.parentWidth - this.x;
				this.componentData.config.parser.left_offset = this.parentLeft + this.x;
				this.stopped.emit(this.componentData);
			}
		}
	}

	constructor(private el: ElementRef) {}
}
